import React from "react";

const EmptyState = ({ 
  title = "Нет данных", 
  description = "Здесь пока ничего нет", 
  icon: Icon,
  action 
}) => {
  return (
    <div className="flex flex-col items-center justify-center p-8 text-center">
      {Icon && <Icon className="w-16 h-16 text-gray-400 mb-4" />}
      <h3 className="text-lg font-medium text-gray-900 mb-2">{title}</h3>
      <p className="text-gray-500 mb-4">{description}</p>
      {action && action}
    </div>
  );
};

export default EmptyState; 